export const cutBase64Prefix = (base64: string) =>
  base64.replace(/^data:[a-z]+\/[a-z+]+;base64,/, '');

export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
